import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { ContentPromotionFormQuestion } from "@/types/models/ContentPromotionFormQuestion.interface";
import { SubjectProductSlug } from "../../types";

const useLazyContentPromotionFormQuestionsGet = (
  productSlug?: SubjectProductSlug,
) => {
  const requestUrl = `${MONOLITH_ORIGIN}/api/v3/platform-alignment-form-question/?product_slug=${productSlug || ""}`;
  return useLazyRestQuery(requestUrl, { skip: !productSlug }) as [
    () => void,
    {
      data: ContentPromotionFormQuestion[] | undefined;
      error: Error;
      loading: boolean;
    },
  ];
};

export default useLazyContentPromotionFormQuestionsGet;
